import styled from '@emotion/styled';

export const FilterHeadline = styled.div(
  ({theme}) => theme.typography.headlineMedium
);
